import * as React from 'react';
import { Feature, SelectList } from '@tencent/workbench';
import i18n from '@i18next/i18n';
import BaseToolbarFeature from '@framework/workbench/common/feature/base-toolbar-feature';
import { config } from './config';
import { getFontSizeConfigData } from '@editor/src/js/constants/toolbar-data';

const FONT_SIZE_SELECT_LIST_WIDTH = 85;
// 设置火狐浏览器的scrollbar的宽度
const FIREFOX_SCROLL_BAR_WIDTH = 'thin';
const FONT_SIZE = 'font-size-';
const PT = 'pt';
const PLUS = '+';
const EMPTY_STRING = '';
const FONT_SIZE_TEXT = '字号';

@Feature()
export class FontSizeFeature extends BaseToolbarFeature {
    id = config.id;
    config = config;
    constructor() {
        super();
    }

    public getFontSize() {
        const values = this.getMenuManager()?.toolbarMenu().values;
        return values?.fontSize;
    }

    public getFontSizeName() {
        const disableItems = this.getMenuManager()?.disableItemIds() || [];
        if (disableItems.find(item => item.id === this.id)) {
            return i18n.t(FONT_SIZE_TEXT);
        }
        const values = this.getMenuManager()?.toolbarMenu().values;
        let fontSize = values?.fontSize || EMPTY_STRING;
        fontSize = fontSize.replace(FONT_SIZE, EMPTY_STRING).replace(PT, EMPTY_STRING);
        let havePlus = false;
        if (fontSize.includes(PLUS)) {
            fontSize = fontSize.replace(PLUS, EMPTY_STRING);
            havePlus = true;
        }
        const fontSizeNumber = Number(fontSize);
        if (!isNaN(fontSizeNumber)) {
            fontSize = String(Number((fontSizeNumber * 10).toFixed(0)) / 10);
        }

        if (havePlus) {
            fontSize += PLUS;
        }

        return fontSize;
    }

    public renderSelectList(isDrawer?: boolean) {
        return (
            <SelectList
                style={{ width: FONT_SIZE_SELECT_LIST_WIDTH, scrollbarWidth: FIREFOX_SCROLL_BAR_WIDTH }}
                selected={this.getFontSize()}
                items={getFontSizeConfigData()}
                onChange={(fontSize: string) => {
                    isDrawer ? this.drawerCallback(fontSize) : this.callback(fontSize);
                }}
            />
        );
    }
}
